import styled from 'styled-components';
import { accentColorPrim, white, orange } from '../../assets/styledAssets/vars';
import * as CSS from 'csstype';
import Button from "../../components/Button/Button.component";

interface CardProperties {
  active?: boolean;
}

export const Card = styled.div<Partial<CSS.Properties & CardProperties>>`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 0.2s;
  padding: 3.5rem;
  border-radius: 2.4rem;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  background-color: ${(props) => (props.active ? accentColorPrim : white)};
  ${(props) => (props.active ? ` div, sub, sup{color:${white};` : '')}
`;

export const StyledSup = styled.sup`
  font-size: 3.2rem;
  color: ${accentColorPrim};
`;

export const StyledSub = styled.sub`
  font-size: 3.2rem;
  color: ${accentColorPrim};
`;

export const StyledDelete = styled(Button)`
  background-color: ${orange};
`;
